import {
  FETCH_AUDIENCES,
  ADD_AUDIENCE,
  ADD_SELECTED_AUDIENCE,
  REMOVE_AUDIENCE,
  CLEAR_AUDIENCE_STATE
} from './mutations-types'

export default {
  [FETCH_AUDIENCES] (state, payload) {
    state.audiences = payload
  },
  [ADD_AUDIENCE] (state, payload) {
    state.audiences.unshift(payload)
  },
  [ADD_SELECTED_AUDIENCE] (state, payload) {
    state.selectedAudience = payload
  },
  [REMOVE_AUDIENCE] (state, payload) {
    let index = state.audiences.findIndex(a => a.id === payload)
    if (index > -1) state.audiences = state.audiences.filter(a => a.id !== payload)
  },
  [CLEAR_AUDIENCE_STATE] (state) {
    state.audiences = []
  }
}
